// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var formatNumber = function (value) {
    // Ensure the input is a number, or parse it from a string
    var numberValue = 0;
    if (typeof value === "string") {
        try {
            numberValue = parseFloat(value);
        }
        catch (e) {
            return value;
        }
    }
    else {
        numberValue = value;
    }
    // Return formatted number or handle invalid inputs gracefully
    // This can happen when the string is for example `-`
    if (isNaN(numberValue)) {
        return value.toString(); // Fallback: return the original value
    }
    return new Intl.NumberFormat("en-US").format(numberValue);
};
